import { Pipe, PipeTransform } from '@angular/core';

import { toKebabCase } from '@fcom/ui-components/utils/string.utils';

@Pipe({
  name: 'finKebab',
  standalone: false,
})
export class KebabPipe implements PipeTransform {
  transform(input: string): string {
    return toKebabCase(input);
  }
}
